<template>
  <div>
    <label>Pay Tier: </label>
    <input-button-list
      :value="[counselor.payroll.tier]"
      label=""
      :allow-two-stack="false"
      :multiple="false"
      :options="[{ id: 'Tier1', display_label: 'Tier 1' }, { id: 'Tier2', display_label: 'Tier 2' },{ id: 'Tier3', display_label: 'Tier 3' }]"
      :force-full-width-inputs="false"
      @input="setTier($event)"
    />
  </div>
</template>

<script>
import PayrollClient from '@/api/CounselorManagement/PayrollClient';
import InputButtonList from '@/components/inputs/InputButtonList.vue';

export default {
    name: 'TierPicker',

    components: {
        InputButtonList,
    },
    props: {
        counselor: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            payrollClient: new PayrollClient(this.$http)
        }
    },
    methods: {
      async setTier(event) {
        try {
          this.counselor.payroll.tier = event[0];
          await this.payrollClient.setPayroll(this.counselor.id, this.counselor.payroll.tier, this.counselor.payroll.paidAs);
        } catch (error) {
          console.error(error);
        }
      }
  }
}
</script>

<style lang="scss" scoped>

label {
    @include label;

    display: block;
    margin-bottom: 10px;
  }

</style>
